import {FollowButton, FollowButtonReadonly} from '../lib/follow-button';
import {CompanyInformationBody} from './body';
import {CompanyInformationBottom} from './bottom';
import {CompanyInformationCompanyLogo} from './company-logo';
import {CompanyInformationCompanyName} from './company-name';
import {CompanyInformationDocumentBanner} from './document-banner';
import {CompanyInformationFollowCount} from './follower-count';
import {CompanyInformationOverview} from './overview';
import {CompanyInformationRssLink} from './rss-link';
import {CompanyInformationRoot} from './root';
import {CompanyInformationTable} from './table';
import {CompanyInformationTitle} from './title';

export const companyInformation = {
  root: CompanyInformationRoot,
  title: CompanyInformationTitle,
  body: CompanyInformationBody,
  overview: CompanyInformationOverview,
  companyLogo: CompanyInformationCompanyLogo,
  companyName: CompanyInformationCompanyName,
  followerCount: CompanyInformationFollowCount,
  rssLink: CompanyInformationRssLink,
  followButton: FollowButton,
  followButtonReadonly: FollowButtonReadonly,
  table: CompanyInformationTable,
  bottom: CompanyInformationBottom,
  documentBanner: CompanyInformationDocumentBanner,
};
